<template>
  <div class="room-create-pay-fee-container">
    <el-card class="box-card">
      <div slot="header" class="flex justify-between">
        <span>{{ $t('roomCreatePayFee.title') }}</span>
      </div>

      <el-row :gutter="20">
        <el-col :span="24">
          <el-form ref="form" :model="roomCreatePayFeeInfo" label-width="120px">
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item :label="$t('roomCreatePayFee.feeType')">
                  <el-select v-model="roomCreatePayFeeInfo.feeTypeCd" @change="changeFeeTypeCd" style="width:100%"
                    :placeholder="$t('roomCreatePayFee.selectFeeType')">
                    <template v-for="(item, index) in roomCreatePayFeeInfo.feeTypeCds">
                      <el-option :key="index" :label="item.name" :value="item.statusCd">
                      </el-option>
                    </template>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item :label="$t('roomCreatePayFee.feeItem')">
                  <el-select v-model="roomCreatePayFeeInfo.configId" @change="roomCreatePayFeeIfOnceFee"
                    style="width:100%" :placeholder="$t('roomCreatePayFee.selectFeeItem')">
                    <template v-for="(item, index) in roomCreatePayFeeInfo.feeConfigs">
                      <el-option :key="index" :label="item.feeName" :value="item.configId">
                      </el-option>
                    </template>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item :label="$t('roomCreatePayFee.startMonth')">
                  <el-date-picker v-model="startMonth" type="month" style="width:100%"
                    value-format="yyyy-MM" :placeholder="$t('roomCreatePayFee.selectStartMonth')" @change="onStartMonthChange">
                  </el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item :label="$t('roomCreatePayFee.endMonth')">
                  <el-date-picker v-model="endMonth" type="month" style="width:100%"
                    value-format="yyyy-MM" :placeholder="$t('roomCreatePayFee.selectEndMonth')" @change="onEndMonthChange">
                  </el-date-picker>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item :label="$t('roomCreatePayFee.startTime')">
                  <el-date-picker v-model="roomCreatePayFeeInfo.startTime" type="date" style="width:100%" value-format="yyyy-MM-dd"
                    :placeholder="$t('roomCreatePayFee.selectStartTime')">
                  </el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item :label="$t('roomCreatePayFee.endTime')">
                  <el-date-picker v-model="roomCreatePayFeeInfo.endTime" type="date" style="width:100%" value-format="yyyy-MM-dd"
                    :placeholder="$t('roomCreatePayFee.selectEndTime')">
                  </el-date-picker>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row :gutter="20" v-if="roomCreatePayFeeInfo.computingFormula == '4004' || roomCreatePayFeeInfo.computingFormula == '7007'">
              <el-col :span="12">
                <el-form-item :label="$t('roomCreatePayFee.amount')">
                  <el-input v-model="roomCreatePayFeeInfo.amount" :placeholder="roomCreatePayFeeInfo.computingFormula == '7007' ? '不填则按公式生成' : $t('roomCreatePayFee.inputAmount')">
                  </el-input>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row :gutter="20" v-if="roomCreatePayFeeInfo.computingFormula == '1102'">
              <el-col :span="12">
                <el-form-item :label="$t('roomCreatePayFee.rateCycle')">
                  <el-input v-model="roomCreatePayFeeInfo.rateCycle"
                    :placeholder="$t('roomCreatePayFee.inputRateCycle')">
                  </el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item :label="$t('roomCreatePayFee.rate')">
                  <el-input v-model="roomCreatePayFeeInfo.rate" :placeholder="$t('roomCreatePayFee.inputRate')">
                  </el-input>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row :gutter="20" v-show="roomCreatePayFeeInfo.computingFormula == '1102'">
              <el-col :span="12">
                <el-form-item :label="$t('roomCreatePayFee.rateStartTime')">
                  <el-date-picker v-model="roomCreatePayFeeInfo.rateStartTime" type="date" style="width:100%"
                    :placeholder="$t('roomCreatePayFee.selectRateStartTime')">
                  </el-date-picker>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item :label="$t('roomCreatePayFee.billMonth')">
                  <el-switch v-model="roomCreatePayFeeInfo.billMonth"
                    active-text="按月拆分" inactive-text="整段创建">
                  </el-switch>
                  <span v-if="roomCreatePayFeeInfo.billMonth && roomCreatePayFeeInfo.startTime && roomCreatePayFeeInfo.endTime"
                    style="margin-left:10px;color:#409EFF;font-size:12px;">
                    {{ $t('roomCreatePayFee.billMonthTip') + calcMonthCount() + $t('roomCreatePayFee.billMonthTipSuffix') }}
                  </span>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item :label="$t('roomCreatePayFee.mergeMode')">
                  <el-switch v-model="roomCreatePayFeeInfo.mergeMode"
                    active-color="#1890FF" inactive-color="#909399">
                  </el-switch>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item :label="$t('roomCreatePayFee.building')">
                  <el-select v-model="roomCreatePayFeeInfo.floorId" @change="loadFloorRooms" style="width:100%"
                    :placeholder="$t('roomCreatePayFee.selectBuilding')">
                    <el-option v-for="(item, index) in roomCreatePayFeeInfo.floors" :key="index" :label="item.floorNum"
                      :value="item.floorId">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item :label="$t('roomCreatePayFee.roomState')">
                  <el-checkbox-group v-model="roomCreatePayFeeInfo.roomState" @change="changeRoomState">
                    <el-checkbox label="2001">{{ $t('roomCreatePayFee.occupied') }}</el-checkbox>
                    <el-checkbox label="2003">{{ $t('roomCreatePayFee.delivered') }}</el-checkbox>
                    <el-checkbox label="2005">{{ $t('roomCreatePayFee.decorated') }}</el-checkbox>
                    <el-checkbox label="2004">{{ $t('roomCreatePayFee.vacant') }}</el-checkbox>
                    <el-checkbox label="2002">{{ $t('roomCreatePayFee.unsold') }}</el-checkbox>
                    <el-checkbox label="2006">{{ $t('roomCreatePayFee.rented') }}</el-checkbox>
                    <el-checkbox label="2007">{{ $t('roomCreatePayFee.sold') }}</el-checkbox>
                  </el-checkbox-group>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row :gutter="20">
              <el-col :span="24" class="text-left">
                <el-form-item :label="$t('roomCreatePayFee.room')">
                  <div v-show="roomCreatePayFeeInfo.rooms && roomCreatePayFeeInfo.rooms.length > 0">
                    <el-checkbox v-model="checkAllRooms" @change="checkAll">{{ $t('roomCreatePayFee.selectAll')
                      }}</el-checkbox>
                    <el-button size="mini" type="text" @click="quickSelectDialog = true">
                      <i class="el-icon-magic-stick"></i>
                      {{ $t('roomCreatePayFee.quickSelect') }}
                    </el-button>
                    <br />
                    <el-checkbox-group v-model="roomCreatePayFeeInfo.roomIds">
                      <el-checkbox v-for="(item, index) in roomCreatePayFeeInfo.rooms" :key="index"
                        :label="item.roomId">
                        <span v-if="item.unitNum != '0'">{{ item.roomName }}</span>
                        <span v-else>{{ item.floorNum }}-{{ item.roomNum }}</span>
                        ({{ item.stateName }})
                      </el-checkbox>
                    </el-checkbox-group>
                  </div>
                  <div v-show="!roomCreatePayFeeInfo.rooms || roomCreatePayFeeInfo.rooms.length < 1">
                    <span>{{ $t('roomCreatePayFee.noRoom') }}</span>
                  </div>
                </el-form-item>
              </el-col>
            </el-row>

            <!-- 快捷勾选对话框：按尾号勾选 -->
            <el-dialog :title="$t('roomCreatePayFee.quickSelectTitle')"
              :visible.sync="quickSelectDialog" width="550px" append-to-body>
              <div class="quick-select-tip">
                <i class="el-icon-info"></i>
                {{ $t('roomCreatePayFee.quickTailTip') }}
              </div>
              <div class="tail-button-group">
                <el-button v-for="tail in availableTails" :key="tail"
                  size="small" style="margin: 3px; min-width: 48px;"
                  :type="selectedTails.includes(tail) ? 'primary' : 'default'"
                  @click="_toggleTail(tail)">
                  {{ tail }}
                </el-button>
              </div>
              <div class="quick-select-preview" v-if="tailPreviewRooms.length > 0">
                <div class="preview-label">
                  {{ $t('roomCreatePayFee.quickSelectPreview') }}: {{ tailPreviewRooms.length }} {{ $t('roomCreatePayFee.roomUnit') }}
                  <el-button type="text" size="mini" @click="_clearTails">{{ $t('roomCreatePayFee.clearSelection') }}</el-button>
                </div>
                <div class="preview-list">
                  <el-tag v-for="(r, i) in tailPreviewRooms" :key="i" size="mini" style="margin: 2px;">
                    {{ r.unitNum != '0' ? r.roomName : (r.floorNum + '-' + r.roomNum) }}
                  </el-tag>
                </div>
              </div>
              <div slot="footer" class="dialog-footer">
                <el-button @click="quickSelectDialog = false">{{ $t('common.cancel') }}</el-button>
                <el-button type="primary" @click="_applyQuickSelect"
                  :disabled="tailPreviewRooms.length < 1">
                  {{ $t('roomCreatePayFee.quickSelectApply') }} ({{ tailPreviewRooms.length }})
                </el-button>
              </div>
            </el-dialog>

            <el-row :gutter="20">
              <el-col :span="24" class="text-right">
                <el-button type="warning" @click="goBack">{{ $t('common.back') }}</el-button>
                <el-button type="primary" @click="saveRoomCreatePayFee">{{ $t('common.submit') }}</el-button>
              </el-col>
            </el-row>
          </el-form>
        </el-col>
      </el-row>
    </el-card>
  </div>
</template>

<script>
import { getCommunityId, getDict } from '@/api/community/communityApi'
import {
  listFeeConfigs,
  queryFloors,
  queryRooms,
  saveRoomCreatePayFee
} from '@/api/fee/roomCreatePayFeeApi'

export default {
  name: 'RoomCreatePayFeeList',
  data() {
    return {
      roomCreatePayFeeInfo: {
        feeTypeCds: [],
        feeConfigs: [],
        remark: '',
        floorId: '',
        communityId: '',
        feeTypeCd: '',
        configId: '',
        roomIds: [],
        rooms: [],
        hasTime: 'OFF',
        startTime: '',
        endTime: new Date().getFullYear() + '-12-31',
        feeFlag: '',
        computingFormula: '',
        amount: '',
        rateCycle: '',
        rate: '',
        rateStartTime: '',
        billMonth: true,
        mergeMode: false,
        roomState: ['2001', '2003', '2005', '2004', '2006', '2007'], // 默认不勾选"未销售"(2002)
        floors: []
      },
      checkAllRooms: false,
      quickSelectDialog: false,
      selectedTails: [],
      startMonth: '',
      endMonth: ''
    }
  },
  computed: {
    // 从房间列表中提取尾号按钮集合
    // 数字末位（如 0101 → 01）按 2 位分组
    // 字母末位（如 02C → C）按 1 位分组
    availableTails() {
      const rooms = this.roomCreatePayFeeInfo.rooms || []
      const tails = new Set()
      for (const r of rooms) {
        const name = r.unitNum != '0' ? r.roomName : `${r.floorNum}-${r.roomNum}`
        const last = name.split('-').pop()
        if (!last) continue
        const ch = last[last.length - 1]
        if (/[0-9]/.test(ch)) {
          // 末位是数字：取最后 2 位
          if (last.length >= 2) tails.add(last.slice(-2))
        } else {
          // 末位是字母：按末位单字符分组
          tails.add(ch.toUpperCase())
        }
      }
      // 数字尾号在前按数值升序，字母尾号在后按字母升序
      return Array.from(tails).sort((a, b) => {
        const aNum = /^\d+$/.test(a)
        const bNum = /^\d+$/.test(b)
        if (aNum && bNum) return parseInt(a) - parseInt(b)
        if (aNum) return -1
        if (bNum) return 1
        return a.localeCompare(b)
      })
    },
    tailPreviewRooms() {
      if (this.selectedTails.length === 0) return []
      const rooms = this.roomCreatePayFeeInfo.rooms || []
      const matched = []
      for (const r of rooms) {
        const name = r.unitNum != '0' ? r.roomName : `${r.floorNum}-${r.roomNum}`
        const last = name.split('-').pop()
        for (const tail of this.selectedTails) {
          // 数字尾号：endsWith 后2位
          // 字母尾号：比较末位字符
          if (last) {
            if (/^\d+$/.test(tail)) {
              if (last.endsWith(tail)) {
                matched.push(r)
                break
              }
            } else {
              if (last.slice(-1).toUpperCase() === tail) {
                matched.push(r)
                break
              }
            }
          }
        }
      }
      return matched
    }
  },
  created() {
    this.initData()
  },
  methods: {
    async initData() {
      this.roomCreatePayFeeInfo.communityId = getCommunityId()
      const now = new Date()
      const yyyyMM = `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}`
      this.startMonth = yyyyMM
      this.endMonth = yyyyMM
      this.onStartMonthChange(yyyyMM)
      this.onEndMonthChange(yyyyMM)
      await this.loadFeeTypeCds()
      await this.loadFloors()
    },
    async loadFeeTypeCds() {
      try {
        const data = await getDict('pay_fee_config', 'fee_type_cd')
        this.roomCreatePayFeeInfo.feeTypeCds = data
      } catch (error) {
        console.error('Failed to load fee types:', error)
      }
    },
    async loadFloors() {
      try {
        const params = {
          page: 1,
          row: 100,
          communityId: this.roomCreatePayFeeInfo.communityId
        }
        const { apiFloorDataVoList } = await queryFloors(params)
        this.roomCreatePayFeeInfo.floors = apiFloorDataVoList
      } catch (error) {
        console.error('Failed to load floors:', error)
      }
    },
    async changeFeeTypeCd(feeTypeCd) {
      this.roomCreatePayFeeInfo.configId = ''

      try {
        const params = {
          page: 1,
          row: 500,
          communityId: this.roomCreatePayFeeInfo.communityId,
          feeTypeCd: feeTypeCd,
          isDefault: 'F',
          valid: '1'
        }
        const { feeConfigs } = await listFeeConfigs(params)
        this.roomCreatePayFeeInfo.feeConfigs = feeConfigs
      } catch (error) {
        console.error('Failed to load fee configs:', error)
      }
    },
    async loadFloorRooms() {
      this.roomCreatePayFeeInfo.rooms = []
      this.roomCreatePayFeeInfo.roomIds = []

      if (!this.roomCreatePayFeeInfo.floorId) return

      try {
        const params = {
          page: 1,
          row: 2000,
          communityId: this.roomCreatePayFeeInfo.communityId,
          floorId: this.roomCreatePayFeeInfo.floorId,
          roomState: this.roomCreatePayFeeInfo.roomState.join(',')
        }
        const { rooms } = await queryRooms(params)
        this.roomCreatePayFeeInfo.rooms = rooms
        if (rooms && rooms.length > 0) {
          this.roomCreatePayFeeInfo.roomIds = rooms.map(room => room.roomId)
        }
      } catch (error) {
        console.error('Failed to load rooms:', error)
      }
    },
    changeRoomState() {
      setTimeout(() => {
        this.loadFloorRooms()
      }, 1000)
    },
    roomCreatePayFeeIfOnceFee(configId) {
      const config = this.roomCreatePayFeeInfo.feeConfigs.find(item => item.configId === configId)
      if (config) {
        this.roomCreatePayFeeInfo.feeFlag = config.feeFlag
        this.roomCreatePayFeeInfo.computingFormula = config.computingFormula
      }
      // 公摊/水/电费用自动开启智能合并，避免重复创建和预缴费冲突
      // 注意：不要对不在白名单里的费用类型（如物业费）强制置为 false，
      // 否则用户手动打开"智能合并"开关后，一改动费用项目就被覆盖回关闭，导致开关"没用"。
      // 后端 tryMergeExistingFee 按【房间+费用项+月份】匹配，并不限制费用类型，物业费同样支持。
      const autoMergeFeeTypes = ['888800010015', '888800010016', '888800010017']
      if (autoMergeFeeTypes.includes(this.roomCreatePayFeeInfo.feeTypeCd)) {
        this.roomCreatePayFeeInfo.mergeMode = true
      }
    },
    checkAll(checked) {
      if (checked) {
        this.roomCreatePayFeeInfo.roomIds = this.roomCreatePayFeeInfo.rooms.map(room => room.roomId)
      } else {
        this.roomCreatePayFeeInfo.roomIds = []
      }
    },
    _toggleTail(tail) {
      const idx = this.selectedTails.indexOf(tail)
      if (idx >= 0) {
        this.selectedTails.splice(idx, 1)
      } else {
        this.selectedTails.push(tail)
      }
    },
    _clearTails() {
      this.selectedTails = []
    },
    _applyQuickSelect() {
      const matchedIds = this.tailPreviewRooms.map(r => r.roomId)
      this.roomCreatePayFeeInfo.roomIds = matchedIds
      this.quickSelectDialog = false
      this.selectedTails = []
      this.$message.success(`已勾选 ${matchedIds.length} 个房间`)
    },
    async saveRoomCreatePayFee() {
      if (!this.validate()) {
        this.$message.error(this.$t('roomCreatePayFee.validateError'))
        return
      }

      if (!this.roomCreatePayFeeInfo.roomIds || this.roomCreatePayFeeInfo.roomIds.length < 1) {
        this.$message.error(this.$t('roomCreatePayFee.noRoomSelected'))
        return
      }

      try {
        const params = { ...this.roomCreatePayFeeInfo }
        if (this.roomCreatePayFeeInfo.billMonth) {
          params.billType = 'MONTH'
        }
        // 后端 tryMergeExistingFee 判断的是字符串 "true"（"true".equals(getString("mergeMode"))），
        // 开关本身是 boolean，统一转成字符串，避免经数据总线传递后类型不一致导致合并失效
        params.mergeMode = this.roomCreatePayFeeInfo.mergeMode ? 'true' : 'false'
        await saveRoomCreatePayFee(params)
        this.$message.success(this.$t('common.operationSuccess'))
        // 保留费用类型/收费项目/日期等选择，方便连续录入；仅重置楼栋和房间勾选
        this.resetBuildingAndRooms()
      } catch (error) {
        this.$message.error(error.message || this.$t('common.saveFailed'))
      }
    },
    resetBuildingAndRooms() {
      this.roomCreatePayFeeInfo.floorId = ''
      this.roomCreatePayFeeInfo.rooms = []
      this.roomCreatePayFeeInfo.roomIds = []
      this.checkAllRooms = false
      this.selectedTails = []
    },
    validate() {
      if (!this.roomCreatePayFeeInfo.configId) {
        return false
      }
      return true
    },
    goBack() {
      this.$router.go(-1)
    },
    _lastDayOfMonth(yyyyMM) {
      const parts = yyyyMM.split('-')
      const y = parseInt(parts[0])
      const m = parseInt(parts[1])
      return `${yyyyMM}-${String(new Date(y, m, 0).getDate()).padStart(2, '0')}`
    },
    onStartMonthChange(val) {
      if (!val) return
      this.roomCreatePayFeeInfo.startTime = val + '-01'
    },
    onEndMonthChange(val) {
      if (!val) return
      this.roomCreatePayFeeInfo.endTime = this._lastDayOfMonth(val)
    },
    calcMonthCount() {
      if (!this.roomCreatePayFeeInfo.startTime || !this.roomCreatePayFeeInfo.endTime) {
        return 0
      }
      const start = new Date(this.roomCreatePayFeeInfo.startTime)
      const end = new Date(this.roomCreatePayFeeInfo.endTime)
      let months = (end.getFullYear() - start.getFullYear()) * 12 + (end.getMonth() - start.getMonth())
      if (end.getDate() >= start.getDate()) {
        months++
      }
      return Math.max(1, months)
    }
  }
}
</script>

<style lang="scss" scoped>
.room-create-pay-fee-container {
  padding: 20px;

  .quick-select-tip {
    color: #909399;
    font-size: 12px;
    margin-bottom: 10px;
  }
  .tail-button-group {
    margin-bottom: 10px;
    max-height: 240px;
    overflow-y: auto;
    padding: 5px 0;
  }
  .quick-select-preview {
    margin-top: 10px;
    padding: 10px;
    background: #f5f7fa;
    border-radius: 4px;
  }
  .preview-label {
    font-size: 12px;
    color: #606266;
    margin-bottom: 5px;
  }
  .preview-list {
    max-height: 120px;
    overflow-y: auto;
  }

  .box-card {
    margin-bottom: 20px;
  }

  .text-right {
    text-align: right;
  }

  .el-checkbox-group {
    margin-top: 10px;

    .el-checkbox {
      margin-right: 15px;
      margin-bottom: 10px;
    }
  }
}
</style>